import React from 'react';

import { connect } from 'react-redux';

import DeferredModal from '@src/components/DeferredModal/DeferredModal';

import { CLOSE_MODAL } from './Modals.actions';
import EditModal from '../../components/EditModal';
import ErrorSaveApplicationModal from '../../components/SaveApplication/ErrorModal/ErrorSaveApplicationModal';
import AccountCreatedNotification from '../AccountCreatedNotification/AccountCreatedNotification';
import AdditionalGuarantor from '../AdditionalGuarantor';
import AutomatedLendingDecision from '../AutomatedLendingDecision';
import FetchOffersModal from '../Offers/FetchOffersModal';
import CreditCheckConsentModal from '../PersonalInformationDE/CreditCheckConsentModal';

const mapStateToProps = ({ modals }) => ({
    ...modals
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => dispatch({ type: CLOSE_MODAL })
});

class Modals extends React.Component {
    render() {
        const { openModalId, closeModal } = this.props;

        return (
            <div data-testid="modal">
                <EditModal isOpen={openModalId === 'additionalGuarantor'}>
                    <AdditionalGuarantor closeModal={closeModal} />
                </EditModal>

                <AutomatedLendingDecision
                    isOpen={openModalId === 'automatedLendingDecision'}
                    onClose={closeModal}
                />

                <CreditCheckConsentModal
                    isOpen={openModalId === 'creditCheckConsent'}
                />

                <FetchOffersModal
                    isOpen={openModalId === 'fetchOffers'}
                    onClose={closeModal}
                />

                <AccountCreatedNotification
                    isOpen={openModalId === 'accountCreatedNotification'}
                />

                <ErrorSaveApplicationModal
                    isOpen={openModalId === 'errorSaveApplicationModal'}
                    onClose={closeModal}
                />

                <DeferredModal
                    isOpen={openModalId === 'deferredModal'}
                    onClose={closeModal}
                />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
